// Datas de formulário.
//
// Campo `<input type="date">` entrega ISO (`AAAA-MM-DD`) ou string vazia, mas
// nem todo valor chega por ele: registro importado, edição que preenche o campo
// a partir do banco e digitação manual em navegador sem seletor nativo também
// passam por aqui. Por isso a validação confere o formato **e** a existência do
// dia — `2026-02-31` casa com o formato e não existe no calendário.
//
// Tudo trabalha com data local, sem fuso: `new Date('2026-08-30')` é
// interpretado como UTC e, no Brasil, volta um dia. Comparação de vencimento
// errada por um dia é o tipo de bug que só aparece em produção.

const ISO = /^\d{4}-\d{2}-\d{2}$/;

/** Converte ISO em `Date` local, ou `null` se a data não existir. */
export function paraData(valor: string | null | undefined): Date | null {
  if (!valor) return null;

  const texto = valor.slice(0, 10);
  if (!ISO.test(texto)) return null;

  const [ano, mes, dia] = texto.split('-').map(Number);
  const data = new Date(ano, mes - 1, dia);

  // O construtor acomoda o excedente (31/02 vira 03/03): se algum componente
  // mudou, a data informada não existe.
  if (data.getFullYear() !== ano || data.getMonth() !== mes - 1 || data.getDate() !== dia) {
    return null;
  }
  return data;
}

export function dataValida(valor: string | null | undefined): boolean {
  return paraData(valor) !== null;
}

/** Hoje à meia-noite, para comparar dia com dia. */
export function hoje(): Date {
  const agora = new Date();
  agora.setHours(0, 0, 0, 0);
  return agora;
}

/** Hoje em ISO — serve de `max`/`min` nos campos de data. */
export function hojeISO(): string {
  const d = hoje();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mes}-${dia}`;
}

export function noFuturo(valor: string | null | undefined): boolean {
  const data = paraData(valor);
  return data !== null && data.getTime() > hoje().getTime();
}

export function noPassado(valor: string | null | undefined): boolean {
  const data = paraData(valor);
  return data !== null && data.getTime() < hoje().getTime();
}

/** `true` quando `inicio` é anterior ou igual a `fim`. Data inválida não passa. */
export function ateOuIgual(inicio: string, fim: string): boolean {
  const a = paraData(inicio);
  const b = paraData(fim);
  if (!a || !b) return false;
  return a.getTime() <= b.getTime();
}

export const MENSAGEM_DATA = {
  invalida: 'Informe uma data válida.',
  fimAntesDoInicio: 'A data final não pode ser anterior à data de início.',
  naoPodeSerFutura: 'A data não pode ser futura.',
  naoPodeSerPassada: 'A data não pode estar no passado.',
  proximaAntesDaUltima: 'A próxima manutenção não pode ser anterior à última.',
} as const;
